import React, { useEffect, useState } from "react";
import "./AnnualMalar.scss";
import Headernav from "../header_nav/Headernav";
import axios from "axios";
import { API_BASE } from "../apiBase";

const statusLabels = {
  alive: "செயலில் இருக்கிறார்",
  removed: "நீக்கப்பட்டார்",
  expired: "காலமானார்",
};

const AnnualMalar = () => {
  const [years, setYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null);
  const [memberNo, setMemberNo] = useState("");
  const [memberData, setMemberData] = useState(null);
  const [receiptData, setReceiptData] = useState(null);
  const [lookupMessage, setLookupMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [receiveOpen, setReceiveOpen] = useState(false);
  const [receiveType, setReceiveType] = useState("");
  const [receiveDesc, setReceiveDesc] = useState("");
  const [saving, setSaving] = useState(false);

  const resetMember = () => {
    setMemberData(null);
    setReceiptData(null);
    setReceiveOpen(false);
    setReceiveType("");
    setReceiveDesc("");
    setLookupMessage("");
  };

  const fetchYears = async () => {
    try {
      const response = await axios.get(`${API_BASE}/annual_malar_years.php?ensure_current=1`);
      const yearList = Array.isArray(response.data) ? response.data : [];
      setYears(yearList);
      if (yearList.length > 0) {
        setSelectedYear(yearList[0]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchYears();
  }, []);

  const handleYearSelect = (year) => {
    setSelectedYear(year);
    setMemberNo("");
    resetMember();
  };

  const handleSearch = async () => {
    if (!selectedYear) {
      setLookupMessage("ஆண்டு தேர்வு செய்யவும்.");
      return;
    }
    if (!memberNo) {
      setLookupMessage("உறுப்பினர் எண்ணை பதிவு செய்யவும்.");
      return;
    }

    setLoading(true);
    setLookupMessage("");
    setReceiveOpen(false);
    setReceiveType("");
    setReceiveDesc("");

    try {
      const response = await axios.get(
        `${API_BASE}/annual_malar_member_lookup.php?member_no=${memberNo}&year=${selectedYear}`
      );
      if (!response.data || !response.data.exists) {
        setMemberData(null);
        setReceiptData(null);
        setLookupMessage("உறுப்பினர் கிடைக்கவில்லை.");
      } else {
        setMemberData(response.data.member);
        setReceiptData(response.data.receipt || null);
      }
    } catch (error) {
      console.log(error);
      setLookupMessage("தகவல் பெற முடியவில்லை.");
    }
    setLoading(false);
  };

  const handleReceive = () => {
    setReceiveOpen(true);
    setReceiveType("");
    setReceiveDesc("");
  };

  const handleSaveReceive = async () => {
    if (!receiveType) {
      setLookupMessage("வாங்குபவர் வகையை தேர்வு செய்யவும்.");
      return;
    }
    if (receiveType === "other" && !receiveDesc.trim()) {
      setLookupMessage("விளக்கம் பதிவு செய்யவும்.");
      return;
    }

    setSaving(true);
    setLookupMessage("");
    try {
      const fd = new FormData();
      fd.append("year", selectedYear);
      fd.append("member_no", memberData.member_no);
      fd.append("received_by_type", receiveType);
      fd.append("received_by_desc", receiveType === "other" ? receiveDesc : "");
      fd.append("received_by_name", localStorage.getItem("user") || "");

      const response = await axios.post(`${API_BASE}/annual_malar_receive.php`, fd);
      if (response.data && response.data.success) {
        await handleSearch();
      } else {
        const msg = response.data && response.data.error ? response.data.error : "சேமிக்க முடியவில்லை.";
        setLookupMessage(msg);
      }
    } catch (error) {
      console.log(error);
      setLookupMessage("சேமிக்க முடியவில்லை.");
    }
    setSaving(false);
  };

  const status = memberData ? memberData.member_current_status : "";
  const isNotEligible = status === "removed" || status === "expired";

  return (
    <>
      <Headernav />
      <div className="annual-malar-page">
        <div className="annual-malar-content">
          <h2 className="annual-malar-title">ஆண்டு மலர்</h2>

          <div className="year-grid">
            {years.map((year) => (
              <button
                key={year}
                type="button"
                className={`year-card ${selectedYear === year ? "active" : ""}`}
                onClick={() => handleYearSelect(year)}
              >
                <div className="year-number">{year}</div>
                <div className="year-label">ஆண்டு மலர்</div>
              </button>
            ))}
          </div>

          {selectedYear && (
            <div className="search-panel">
              <div className="search-row">
                <label className="search-label">உறுப்பினர் எண்</label>
                <input
                  type="number"
                  value={memberNo}
                  onChange={(e) => setMemberNo(e.target.value)}
                  className="search-input"
                />
                <button type="button" className="search-button" onClick={handleSearch} disabled={loading}>
                  Search
                </button>
                {loading && <span className="search-hint">Loading...</span>}
              </div>

              {lookupMessage && <div className="info-message">{lookupMessage}</div>}

              {memberData && (
                <div className={`member-card status-${status}`}>
                  <div className="member-header">
                    <div>
                      <div className="member-name">
                        {memberData.member_name}
                        <span className="member-no">#{memberData.member_no}</span>
                      </div>
                      <div className="member-meta">
                        s/o {memberData.father_name} • {memberData.city}
                      </div>
                    </div>
                    <div className={`status-pill status-${status}`}>
                      {statusLabels[status] || status}
                    </div>
                  </div>

                  {isNotEligible && (
                    <div className="member-alert">
                      நீக்கப்பட்டார் / காலமானார் - விநியோகம் இல்லை
                    </div>
                  )}

                  {!isNotEligible && receiptData && (
                    <div className="received-badge">
                      Received ({receiptData.received_by_type})
                      {receiptData.received_by_desc ? ` - ${receiptData.received_by_desc}` : ""}
                    </div>
                  )}

                  {!isNotEligible && !receiptData && (
                    <div className="receive-section">
                      {!receiveOpen && (
                        <button type="button" className="receive-button" onClick={handleReceive}>
                          Receive
                        </button>
                      )}

                      {receiveOpen && (
                        <div className="receive-form">
                          <div className="radio-row">
                            <label>
                              <input
                                type="radio"
                                name="receiveType"
                                value="self"
                                checked={receiveType === "self"}
                                onChange={(e) => setReceiveType(e.target.value)}
                              />
                              Self
                            </label>
                            <label>
                              <input
                                type="radio"
                                name="receiveType"
                                value="other"
                                checked={receiveType === "other"}
                                onChange={(e) => setReceiveType(e.target.value)}
                              />
                              Others
                            </label>
                          </div>
                          {receiveType === "other" && (
                            <textarea
                              className="receive-textarea"
                              rows={3}
                              placeholder="விளக்கம்"
                              value={receiveDesc}
                              onChange={(e) => setReceiveDesc(e.target.value)}
                            />
                          )}
                          <button
                            type="button"
                            className="save-button"
                            onClick={handleSaveReceive}
                            disabled={saving}
                          >
                            Save
                          </button>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}

              
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AnnualMalar;
